import React, { useEffect, useState } from 'react';
import { Info, Globe } from 'lucide-react';
import services from '../../services';
import ResponsivePagination from "react-responsive-pagination";

export function MessageThread({ taskId }) {
  const [message, setMessage] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const totalPages = Math.ceil(totalCount / limit);
  const getChatsDetails = async () => {
    try {
      const query = new URLSearchParams({ page, limit }).toString();
      const response = await services.task.GET_CHAT_DETAILS(taskId, query);
      setMessage(response?.data?.data);
      setTotalCount(response?.data?.totalPages || 0);
    } catch (error) {
      console.error('Error fetching chat details:', error);
    }
  }
  useEffect(() => {
    getChatsDetails();
  }, [page]);

  return (
    <div className=" mx-auto space-y-4" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
      {message.map((msg) => (
        <div key={msg.id}>
          {msg.type === 'email' || msg.type === 'subEmail' || msg.type === 'notification' ? (
            <NotificationMessage text='BuCountry Tours was notified via Email.' timestamp={msg.createdAt} message={msg.body} />
          ) : (
            <UserMessage
              avatar={msg.participantName.charAt(0).toUpperCase()}
              name={msg.participantName}
              timestamp={msg.createdAt}
              message={msg.message}
            />
          )}
        </div>
      ))}
      {totalPages > 1 && (
        <>
          <div style={{ marginTop: "20px" }}>
            <ResponsivePagination
              current={page}
              total={totalCount}
              onPageChange={setPage}
            />
          </div>
        </>
      )}
    </div>
  );
}

function NotificationMessage({ text, timestamp, message }) {
  const formatMailBody = (body) => {
    if (!body) return '';
    let cleanBody = body;

    cleanBody = cleanBody.replace(/<div<br\/>/gi, '<div><br/>');
    cleanBody = cleanBody.replace(/<\/div<br\/>/gi, '</div><br/>');
    cleanBody = cleanBody.replace(/<a href="([^"]*)"<br\/>/gi, '<a href="$1">');

    const pattern = /(On .*wrote:)/gi;
    cleanBody = cleanBody.replace(
      pattern,
      `<br/><span style="font-size:13px; color:#6a6a6a;">$1</span>` +
      `<blockquote style="margin:0 0 0 .8ex; border-left:1px solid #ccc; padding-left:1ex; color:#202124;">`
    );

    cleanBody = cleanBody.replace(/<\/a<br\/>/gi, '</a><br/>');
    cleanBody = cleanBody.replace(/<blockquote<br\/>/gi, '<blockquote style="margin:0 0 0 .8ex; border-left:1px solid #ccc; padding-left:1ex; color:#202124;">');
    cleanBody = cleanBody.replace(/<\/blockquote<br\/>/gi, '</blockquote>');
    cleanBody = cleanBody.replace(/<span<br\/>/gi, '<span style="font-size:13px; color:#444;">');
    cleanBody = cleanBody.replace(/<\/span<br\/>/gi, '</span>');

    cleanBody = cleanBody.replace(/ontainer"\s*<br\/>/gi, '');
    cleanBody = cleanBody.replace(/<blockquote class="gmail_quote"[^>]*>/gi, ' ');
    cleanBody = cleanBody.replace(/<\/blockquote>/gi, ' ');
    cleanBody = cleanBody.replace(/<div class="gmail_quote[^<]*/gi, '');
    cleanBody = cleanBody.replace(/<div class="gmail_quote[^>]*>[\s\S]*?<\/div>/gi, '');
    cleanBody = cleanBody.replace(/<div class="gmail_attr[^>]*>[\s\S]*?<\/div>/gi, '');

    cleanBody = cleanBody.replace(/<div[^>]*>\s*(?:<br\s*\/?>\s*)*<\/div>/gi, '');
    cleanBody = cleanBody.replace(/<p[^>]*>\s*(?:<br\s*\/?>\s*)*<\/p>/gi, '');

    cleanBody = cleanBody.replace(/(\r\n|\r|\n)/g, '<br/>');
    cleanBody = cleanBody.replace(/(<br\s*\/?>\s*){2,}/gi, '<br/>');
    cleanBody = cleanBody.replace(/^(<br\s*\/?>\s*)+/i, '');
    cleanBody = cleanBody.replace(/(<br\s*\/?>\s*)+$/i, '');

    cleanBody = cleanBody.trim();
    return cleanBody;
  };
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-gray-700">{text}</p>
          {timestamp && <p className="text-xs text-gray-500 mt-1">{timestamp}</p>}
        </div>

      </div>
      <div className="mt-2 bg-gray-100 rounded-lg p-3 text-sm text-gray-700 whitespace-pre-wrap"
        dangerouslySetInnerHTML={{
          __html: formatMailBody(message) || ''
        }}
      />

    </div>
  );
}

function UserMessage({ avatar, name, timestamp, message }) {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0">
        <div className="h-10 w-10 bg-red-600 rounded-full flex items-center justify-center">
          <span className="text-white font-semibold text-sm">{avatar}</span>
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="font-semibold text-gray-900">{name}</p>
          <span className="text-xs text-gray-500">{timestamp}</span>
        </div>
        <div className="mt-2 bg-gray-100 rounded-lg p-3 text-sm text-gray-700 whitespace-pre-wrap">
          {message}
        </div>
      </div>
    </div>
  );
}
